// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__oNzl-","questions":"styles_questions__Tp_gZ","footer":"styles_footer__2MPTg"};